import { useQuery } from "@tanstack/react-query";
import { useQueryError } from "../../../../../hooks/http/useQueryError";
import { Tag } from ".";
import {
  downloadCsvForStudentPasscodeInactivation,
  NO_STUDENT_ERROR,
  path,
  type ResponseSchema,
} from "./downloadCsvForStudentPasscodeInactivation";

export const useFetchCsvForStudentPasscodeInactivation = (
  sectionId: string,
  selectedTags: Tag[],
) => {
  const { error, refetch } = useQuery<ResponseSchema>({
    queryKey: [path, sectionId, selectedTags],
    queryFn: () =>
      downloadCsvForStudentPasscodeInactivation(sectionId, selectedTags),
    enabled: false,
    retry: false,
    staleTime: 0,
    gcTime: 0,
  });

  const shouldUseQueryError =
    error && !(error instanceof Error && error.message === NO_STUDENT_ERROR);

  useQueryError(shouldUseQueryError ? error : null);

  return { downloadStudentsCsv: refetch, error };
};
